class AlsoLikeProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      const response = await fetch(`${location.origin + window.routes.route_url || ''}?sections=${this.dataset.id}`);
      const result = await response.json()
      document.querySelector(`#section-you-may-also-like`).innerHTML = result[this.dataset.id]

    });
    this.showRandomLatestProducts();
  }

  async showRandomLatestProducts() {

    const handlesElement = this.querySelector('.randomize-handles');
    if (!handlesElement) return
    const selectedToView = handlesElement.getAttribute('data-handles').split(',');

    const lastNElements = selectedToView
      .filter(handle => handle.length)
      .sort(() => {
        return .5 - Math.random();
      })
      .slice(0, 4)


    const section = document.querySelector('.section-also-like');

    if (!lastNElements.length) {
      section.classList.add('hidden');
      return;
    }

    const response = await fetch(`${location.origin + window.routes.route_url || ''}/search?view=product-cards&ids=${lastNElements.join(',')}`);
    this.querySelector('.products-grid').innerHTML = await response.text();
  }

}

customElements.define('also-like-products', AlsoLikeProducts);